import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialConfluenceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialConfluence",
    children: /*#__PURE__*/_jsx("path", {
      d: "M23.3 3c-.29.01-.56.16-.72.42v.01c-.23.39-.53.89-.85 1.43-2.38 4.27-4.59 3.31-8.74 1.33l-5.73-2.5a.9.9 0 0 0-1.19.42s0 .02-.01.02l-2.75 5.99c-.19.44 0 .96.44 1.16 1.21.57 3.61 1.7 5.78 2.74C17.32 17.8 23.94 17.55 29 9.33c.29-.47.61-1.02.89-1.45a.89.89 0 0 0-.3-1.21l-5.78-3.55a.84.84 0 0 0-.5-.13Zm-9.7 13.4c-4.02.09-7.58 2.16-10.58 7.04-.29.47-.61 1.02-.89 1.45a.89.89 0 0 0 .3 1.21l5.78 3.55c.42.26.97.13 1.22-.29v-.01c.23-.39.53-.89.85-1.43 2.38-4.27 4.59-3.31 8.74-1.33l5.73 2.5c.44.21.97.02 1.19-.42v-.02l2.76-5.99c.19-.44 0-.96-.44-1.16-1.21-.57-3.61-1.7-5.78-2.74-3.16-1.54-6.14-2.41-8.89-2.35Z"
    })
  }));
};
SocialConfluenceIcon.displayName = 'SocialConfluenceIcon';